import React, { useEffect, useState } from 'react';
import ColorLogo from '../assets/Color logo with background.png';
import WhiteLogo from '../assets/White logo - no background.png';

declare global {
  interface Window {
    Telegram: {
      WebApp: {
        initDataUnsafe: {
          start_param: string;
          user?: {
            first_name: string;
            last_name?: string;
            username?: string;
            photo_url?: string;
          };
        };
        colorScheme: string;
        onEvent: (eventName: string, callback: () => void) => void;
        offEvent: (eventName: string, callback: () => void) => void;
      };
    };
  }
}

export const Header: React.FC = () => {
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  
  useEffect(() => {
    const checkTheme = () => {
      const isDark = window.Telegram.WebApp.colorScheme === 'dark';
      setIsDarkTheme(isDark);
    };
    
    checkTheme();
    
    // Проверяем тему при изменении
    window.Telegram.WebApp.onEvent('themeChanged', checkTheme);
    
    return () => {
      window.Telegram.WebApp.offEvent('themeChanged', checkTheme);
    };
  }, []);
  
  return (
    <header className="sticky top-0 z-10 flex items-center justify-center px-4 pt-3 pb-3 border-b border-tg-secondary-bg bg-tg-bg" style={{ paddingTop: 'calc(var(--tg-safe-area-inset-top, 0px) + 12px)' }}>
      <div className="h-[30px] flex items-center justify-center mt-2 mb-0">
        <img src={isDarkTheme ? WhiteLogo : ColorLogo} alt="BigDeal" className="h-full w-auto object-contain" />
      </div>
    </header>
  );
};
